import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { useDispatch } from 'react-redux';
import phrasesType from '../proptypes/phrases';
import profileWithArchetypeType from '../proptypes/profile-with-archetype';
import selectReferralComparisonTitle from '../selectors/referral-comparison-title';
import AccountLayout from '../layouts/AccountLayout';
import PageSection from '../components/PageSection';
import UnderscoreDivider from '../components/UnderscoreDivider';
import { DisplayHeader } from '../components/Typography';
import ComparisonTable from '../components/ComparisonTable';
import InviteFriends from '../components/invite-friends/InviteFriends';
import { ssColorWhite } from '../constants/style-constants';
import {
  clickComparisonInviteButtonAction,
  copyComparisonInviteUrlAction,
  shareComparisonInviteUrlAction,
} from '../actions/action-creators';

const referredUserHeaderCSS = css`
  padding-bottom: 0;
  margin-bottom: 0;
`;

const displayHeaderCSS = css`
  color: ${ssColorWhite};
`;

const inviteFriendsCSS = css`
  margin-top: 2rem;
`;

const ReferralComparisonPage = ({
  currentProfile,
  comparedProfile,
  phrases,
  urls,
}) => {
  const pageTitle = selectReferralComparisonTitle(
    comparedProfile.profile.fullName,
    phrases.comparison,
  );

  const dispatch = useDispatch();

  const handleInviteButtonClick = () => {
    dispatch(clickComparisonInviteButtonAction({
      profileId: currentProfile.profile.id,
    }));
  };

  const handleCopy = () => {
    dispatch(copyComparisonInviteUrlAction({
      profileId: currentProfile.profile.id,
    }));
  };

  const handleInviteShare = ({ id: socialNetwork }) => {
    dispatch(shareComparisonInviteUrlAction({
      socialNetwork,
      profileId: currentProfile.profile.id,
    }));
  };

  return (
    <AccountLayout>
      <PageSection theme="black" css={referredUserHeaderCSS}>
        <DisplayHeader css={displayHeaderCSS}>
          {pageTitle}
        </DisplayHeader>
        <UnderscoreDivider />
        <InviteFriends
          css={inviteFriendsCSS}
          referralUrl={urls.referralUrl}
          phrases={phrases}
          onMainButtonClick={handleInviteButtonClick}
          onCopy={handleCopy}
          onShare={handleInviteShare}
        />
      </PageSection>
      <ComparisonTable
        currentProfile={currentProfile}
        comparedProfile={comparedProfile}
        phrases={phrases}
        urls={urls}
      />
    </AccountLayout>
  );
};

ReferralComparisonPage.propTypes = {
  currentProfile: profileWithArchetypeType.isRequired,
  comparedProfile: profileWithArchetypeType.isRequired,
  phrases: phrasesType.isRequired,
  urls: PropTypes.shape({
    gamesPath: PropTypes.string.isRequired,
    currentProfileSpyRolePath: PropTypes.string.isRequired,
    specialOpsVideoPath: PropTypes.string.isRequired,
    referralUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default ReferralComparisonPage;
